import { getJSON } from 'bv';

export default () => getJSON('/bv_api/live_chat_settings');
